module.exports = __webpack_public_path__ + "statics/media/aspire-logo_black.92d495a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/aspire-logo/aspire-logo_black.svg
// module id = 1211
// module chunks = 138